import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Settings.svg'

export const IconSettings = IconSVG as IconComponent
